import { gql } from '@apollo/client'
import { BodyText, Heading } from '@farol-ds/react'
import { Price } from '@jusbrasil-web/shared-price'

import { CheckoutButton } from '../checkout-button'
import { OneClickButton } from '../one-click-button'
import {
  CaseTrackingBgCheckFromBgCheckOfferContent_OfferLockDataFragment,
  CaseTrackingBgCheckFromBgCheckOfferContent_ViewerFragment,
} from './__generated__/case-tracking-bg-check-from-bg-check-offer-content.graphql'
import styles from './case-tracking-bg-check-from-bg-check-offer-content.module.scss'

export interface CaseTrackingBGCheckFromBgCheckOfferContentProps {
  offerLockData: CaseTrackingBgCheckFromBgCheckOfferContent_OfferLockDataFragment
  viewer: CaseTrackingBgCheckFromBgCheckOfferContent_ViewerFragment
}

export function CaseTrackingBGCheckFromBgCheckOfferContent({
  offerLockData,
  viewer,
}: CaseTrackingBGCheckFromBgCheckOfferContentProps) {
  const { body, header } = offerLockData || {}
  const { title = '', subtitle = '' } = header || {}
  const {
    cards: [card],
  } = body || {}
  const currentPlanPriceText = card.offer.currentPlanPriceText || ''
  const frequency = card.offer.frequencyPeriodText

  return (
    <>
      <div
        className={styles.header}
        data-testid="case-tracking-bg-check-from-bg-check-offer-content"
      >
        <Heading size="lg" className={styles.title}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>
        <BodyText size="md" className={styles.subtitle}>
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
      </div>

      <div className={styles.card}>
        <div className={styles.wrapperPrice}>
          <Price align="center" size="lg">
            <Price.Discount className={styles.priceDiscountText}>
              <span
                className={styles.currentPlanPriceText}
                dangerouslySetInnerHTML={{ __html: currentPlanPriceText }}
              />
            </Price.Discount>

            <Price.Value>
              <span className={styles.planContainerPriceText}>{card.offer.priceText}</span>

              <Price.ValueFrequency>
                <span className={styles.frequencyPeriodText}>{frequency}</span>
              </Price.ValueFrequency>
            </Price.Value>
          </Price>

          <CheckoutButton offerLockCard={card} kind="primary" viewer={viewer} />
          <OneClickButton offerLockCard={card} viewer={viewer} kind="primary" />
        </div>
      </div>
    </>
  )
}

CaseTrackingBGCheckFromBgCheckOfferContent.fragments = {
  offerLockData: gql`
    fragment CaseTrackingBGCheckFromBgCheckOfferContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          offer {
            priceTitle
            priceText
            priceAfterPromotionalPeriodText
            installmentsText
            frequencyPeriodText
            currentPlanPriceText
          }
          ...OneClickButton_offerLockCard
          ...CheckoutButton_offerLockCard
        }
      }
    }
    ${OneClickButton.fragments.offerLockCard}
    ${CheckoutButton.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment CaseTrackingBGCheckFromBgCheckOfferContent_viewer on Profile {
      ...OneClickButton_viewer
      ...CheckoutButton_viewer
    }
    ${OneClickButton.fragments.viewer}
    ${CheckoutButton.fragments.viewer}
  `,
}
